import { render } from "./ReducedLayout.vue?vue&type=template&id=845cb2e6"
import script from "./ReducedLayout.vue?vue&type=script&lang=js"
export * from "./ReducedLayout.vue?vue&type=script&lang=js"

import "./ReducedLayout.vue?vue&type=style&index=0&id=845cb2e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__